export default "__VITE_ASSET__BdHKZqrd__"